import { Component } from '@angular/core';
import { AlertController, NavController } from 'ionic-angular';
import { PostRegisterObject, PostRegisterResponse } from '../../../interfaces/api';
import { RegisterThankYouPage } from './thank-you/thank-you';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';
import { Api } from '../../../providers/api';
import * as HttpStatus from 'http-status-codes';

interface MissingRegistrationInputs {
    attempt: boolean;
    name: boolean;
    email: boolean;
    phone: boolean;
}

@Component({
    selector: 'page-register',
    templateUrl: 'register.html',
})
export class RegisterPage {

    missing: MissingRegistrationInputs = {
        attempt: false,
        name: false,
        email: false,
        phone: false,
    };

    registration: PostRegisterObject = {
        name: '',
        company: '',
        phone: '',
        email: '',
    };

    constructor(
        private alertCtrl: AlertController,
        private api: Api,
        private navCtrl: NavController,
        private spinner: SpinnerDialog,
    ) {
    }

    async register() {
        this.spinner.show();
        this.missing.attempt = true;
        this.validate();

        if (this.fails()) {
            this.errorPrompt({});
            this.spinner.hide();
            return;
        }

        try {

            let response: PostRegisterResponse = await this.api.postRegister(this.registration);
            if (response.success !== undefined && response.success) {
                this.spinner.hide();
                this.navCtrl.setRoot(RegisterThankYouPage, {}, {animate: true, direction: 'back'});
            } else {
                this.spinner.hide();
                this.errorPrompt(null);
            }
            this.spinner.hide();

        } catch (e) {
            this.errorPrompt(e);
            this.spinner.hide();
        }
    }

    changeName() {
        this.missing.name = false;
        if (!this.missing.phone && !this.missing.email)
            this.missing.attempt = false;
    }

    changePhone() {
        this.missing.phone = false;
        if (!this.missing.name && !this.missing.email)
            this.missing.attempt = false;
    }

    changeEmail() {
        this.missing.email = false;
        if (!this.missing.name && !this.missing.phone)
            this.missing.attempt = false;
    }

    private validate() {
        this.missing.name = this.registration.name.length < 1;
        this.missing.phone = this.registration.phone.length < 1;
        this.missing.email = this.registration.email.length < 1;
    }

    private fails(): boolean {
        return this.missing.name || this.missing.phone || this.missing.email;
    }

    private errorPrompt(error: any): void {
        let title: string = 'Registration failed';
        let message: string = '';

        if (this.fails() || error === null) {
            message = 'Check your registration details.';
            return this.presentAlert(title, message);
        }

        if (error.status !== undefined)
            switch (error.status) {
                case HttpStatus.INTERNAL_SERVER_ERROR:
                    message = 'An unknown error has occurred.';
                    break;
                default:
                    message = 'Check your registration details.';

            }

        return this.presentAlert(title, message);
    }

    private presentAlert(title: string, message: string): void {

        let prompt = this.alertCtrl.create({
            title: title,
            subTitle: message,
            buttons: ['OK']
        });
        prompt.present();
    }

}



// WEBPACK FOOTER //
// ./src/pages/auth/register/register.ts